import { io } from 'socket.io-client';
import { Config } from "../config/Config";
// "undefined" means the URL will be computed from the `window.location` object
let url = Config.REST_API;
let config = localStorage.getItem("appKeyConfig")
if (config) {
    config = JSON.parse(config);
    if (config.REST_API) {
        url = config.REST_API;
    }
}



export const socket = io(url);